import {crudGeneral} from "@/services/resource/GeneralCRUD.service"
import ApexCharts from "apexcharts";
import ui from "@/assets/scripts/ui";

export default {
    ui,
    data() {
        return {
            busy: true,
            report: "",
            loaded:false,
            charts: {
                qtd: 0,
                data: []
            },
        }
    },
    props: {
        reportId: {
            type: Number,
            default: 0,
        },
        type: {
            type: String,
            default: "R",
        },
        title: {
            type: String,
            default: "",
        },
        goBackTitle: String,
        goBackTo: {
            type: String,
            default: "",
        },
        breadcrumb: Array,
        primaryKey: Number,//Enviar quando desejar reordenar listagem
        foreignKey: Number,//Enviar quando desejar reordenar listagem
        primaryKeyColumn: String,//Enviar quando desejar reordenar listagem
        foreignKeyColumn: String,//Enviar quando desejar reordenar listagem

    },
    async mounted() {


    },
    methods: {

        async mountedReport(params) {

            //await this.mountedDefault(true, true, 'report')

            let url = "general/report/generate?platform=web&reportId=" + this.reportId + "&type=" + this.type + "&format=html"
            if (params && Array.from(params).length > 0) {
                url += `&${params}`
            }

            if (this.primaryKey > 0)
                url += `&primaryKey=${this.primaryKey}`


            await crudGeneral.get(url)
                .then(response => {

                    const reportRender = ui.reportRender(response.data)

                    this.report = reportRender.report
                    this.charts = reportRender.charts

                    if (this.charts.length > 0) {

                        setTimeout(() => {

                            for (const chart of this.charts) {
                                new ApexCharts(document.getElementById(chart.id), chart).render()
                            }

                        }, 100)

                    }

                    this.busy = false

                    //Armazena somente a primeira vez que carregou, utilizado em dashboards
                    if(!this.loaded){
                        this.loaded = true
                    }

                })
                .catch(error => {

                    this.busy = false

                    if (error.response) {

                        if (error.response.status === 500) {
                            ui.msg(this, 'Informação', error.response.data.general)
                        }
                    }
                })


        },


    },


}


